const NEW_COMPUTER_ACT_IDS = [98, 99];

const EXAM_CONFIG = {
  normal: {
    english: { questions: 75, minutes: 45 },
    math: { questions: 60, minutes: 60 },
    reading: { questions: 40, minutes: 35 },
    science: { questions: 40, minutes: 35 }
  },
  newComputer: {
    english: { questions: 50, minutes: 35 },
    math: { questions: 45, minutes: 50 },
    reading: { questions: 36, minutes: 40 },
    science: { questions: 40, minutes: 40 }
  }
};

export function isNewComputerAct(actId) {
  return NEW_COMPUTER_ACT_IDS.includes(Number(actId));
}

export function getExamSectionConfig(actId, type) {
  const examType = isNewComputerAct(actId) ? "newComputer" : "normal";
  return EXAM_CONFIG[examType][String(type || "").toLowerCase()];
}

export function getQuestionCount(actId, type) {
  const config = getExamSectionConfig(actId, type);
  return config ? config.questions : 0;
}

export function getSectionDuration(actId, type) {
  const config = getExamSectionConfig(actId, type);
  return config ? config.minutes * 60 : 0;
}

export function getAllSectionDurationMinutes(actId) {
  const config = isNewComputerAct(actId) ? EXAM_CONFIG.newComputer : EXAM_CONFIG.normal;
  return config.english.minutes + config.math.minutes + config.reading.minutes + config.science.minutes;
}

